'use strict';

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').controller('SafrasCtrl', function(
  $scope, $rootScope, $location,
  SafrasService, LoadingService, MessagesService,
) {
  $scope.safras = [];
  $scope.filter = { status: 'all' };

  // eslint-disable-next-line max-lines-per-function
  const initialize = function() {
    LoadingService.showLoading();
    $rootScope.initialize.then(function() {
      if ($scope.$root.parametros.nao_cliente_agrogestao && $rootScope.permissions.safras.canRead) {
        $scope.list();
      } else {
        $location.path('/');
        MessagesService.alert(ACESSO_NAO_PERMITIDO.msg);
        // eslint-disable-next-line no-useless-return
        return;
      }
    });
  };

  $scope.list = function() {
    LoadingService.showLoading();
    $scope.safras = [];

    const filters = {
      status: $scope.filter.status
    };

    SafrasService.listAll(filters).then(function(data) {
      $scope.safras = data.data || [];
    }, function() {
      MessagesService.alert('Não foi possível buscar as safras.');
    })
      .finally(LoadingService.hideLoading);
  };

  $scope.inactivate = function(id) {
    MessagesService
      .confirm('Deseja realmente inativar esta safra?')
      .then(async() => {
        LoadingService.showLoading();
        try {
          await SafrasService.inactivate(id);
          initialize();
        } catch {
          MessagesService.alert('Não foi possível inativar a safra.');
          LoadingService.hideLoading();
        }
      });
  };

  $scope.activate = function(id) {
    MessagesService
      .confirm('Reativar safra?')
      .then(async() => {
        LoadingService.showLoading();
        try {
          await SafrasService.activate(id);
          initialize();
        } catch {
          MessagesService.alert('Não foi possível reativar a safra.');
          LoadingService.hideLoading();
        }
      });
  };

  initialize();

  $scope.edit = function(safraId) {
    $location.path(`/safras/${safraId}/edit`);
  };
});
